import { render, staticRenderFns } from "./QuickReplies.vue?vue&type=template&id=66361042&scoped=true"
import script from "./QuickReplies.vue?vue&type=script&lang=js"
export * from "./QuickReplies.vue?vue&type=script&lang=js"
import style0 from "./QuickReplies.vue?vue&type=style&index=0&id=66361042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66361042",
  null
  
)

export default component.exports